import {
  GetUnseenAnalyticsAlertCountQuery,
  GetUnseenAnalyticsAlertCountQueryVariables,
} from '@/types';
import { gql } from '@apollo/client';
import { partnerSupplier } from '@/utils/environment';
import { useAuthenticatedUserContext } from '@/contexts/user-context';
import { useHubLastVisited } from './use-hub-last-visited';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';

export const GET_UNSEEN_ALERTS_QUERY = gql`
  query GetUnseenAnalyticsAlertCount(
    $employeeUUID: uuid!
    $since: timestamptz!
    $businessOrganizationUUID: uuid!
  ) {
    analytics_alerts_aggregate(
      where: {
        chat: {
          supplier: {
            business_organization_uuid: { _eq: $businessOrganizationUUID }
          }
          chats_employees: { employee_uuid: { _eq: $employeeUUID } }
        }
        alert_status: { _eq: "ACTIVE" }
        created_at: { _gte: $since }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const useUnseenAlerts = () => {
  const { user } = useAuthenticatedUserContext();
  const { lastVisitedAt, lastVisitedError, lastVisitedLoading } =
    useHubLastVisited();

  const {
    data: alertData,
    loading: alertLoading,
    refetch: refetchAlerts,
  } = useWrappedQuery<
    GetUnseenAnalyticsAlertCountQuery,
    GetUnseenAnalyticsAlertCountQueryVariables
  >(GET_UNSEEN_ALERTS_QUERY, {
    fetchPolicy: 'no-cache',
    skip:
      lastVisitedAt === null || lastVisitedLoading || Boolean(lastVisitedError),
    variables: {
      businessOrganizationUUID: partnerSupplier.businessOrganizationUUID,
      employeeUUID: user.uuid,
      since: lastVisitedAt!,
    },
  });

  return {
    refetchUnseenAlerts: refetchAlerts,
    unseenAlertsData:
      alertData?.analytics_alerts_aggregate?.aggregate?.count ?? null,
    unseenAlertsLoading: alertLoading,
  };
};
